import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-buyRight",
  "use": "icon-buyRight-usage",
  "viewBox": "0 0 5 8",
  "content": "<symbol viewBox=\"0 0 5 8\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-buyRight\">\n<path id=\"icon-buyRight_Polygon 1\" d=\"M5 4L0.5 7.4641L0.5 0.535898L5 4Z\" fill=\"#03FF00\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol